export const DataLatest = [
  {
    link: "https://nuxt-task-manager.netlify.app/",
    img: "https://res.cloudinary.com/junaid0808/image/upload/v1616661578/Profile/undraw_Map_dark_re_36sy_pptpjj.svg",
    name: "Task Manager Desktop Version",
    description: "Nuxt | Vue | VueX",
    read: "10 min",
  },
  {
    link: "https://chat-app-vue2.netlify.app",
    img: "https://res.cloudinary.com/junaid0808/image/upload/v1616661578/Profile/undraw_Map_dark_re_36sy_pptpjj.svg",
    name: "Chat App",
    description: "Vue | Firebase | FireStore | VueX",
    read: "4 min",
  },
  {
    link: "https://fanagram.netlify.app/",
    img: "https://res.cloudinary.com/junaid0808/image/upload/v1620771850/Projects-Images/markus-spiske-9IDgEybpF6o-unsplash_fso6ic.jpg",
    name: "FanaGram",
    description: "React | Firebase | FireStore | FireStorage",
    read: "10 min",
  },
  {
    link: "https://junaid-simple-recipes.netlify.app/",
    img: "https://res.cloudinary.com/junaid0808/image/upload/v1616661578/Profile/undraw_Map_dark_re_36sy_pptpjj.svg",
    name: "Simple Recipe | Gatsby Project",
    description: "Gatsby Static Site with headless CMS | contentfull | Graphql",
    read: "8 min",
  },
  {
    link: "https://junaid-quiz-app.netlify.app/",
    img: "https://res.cloudinary.com/junaid0808/image/upload/v1616661203/Profile/quiz_v2e3y7.svg",
    name: "Quiz App",
    description:
      "React Application, Using Quiz API. Where you can choose the category,difficulty level and number of questions.",
    read: "15 min",
  },
  {
    link: "https://junaid-snippet-manager.netlify.app/",
    img: "https://res.cloudinary.com/junaid0808/image/upload/v1616660985/Profile/snippet_c0wkjs.svg",
    name: "Snippet Manager",
    description:
      "Mern Stack Application, Where you can create snippet confidencially.For authentication I used JWT and database mongodb.",
    read: "10 min",
  },
  {
    link: "https://junaid-space-x.netlify.app/",
    img: "https://res.cloudinary.com/junaid0808/image/upload/v1616844099/Profile/undraw_Goals_re_lu76_galqxu.svg",
    name: "SpaceX",
    description:
      "React Application with Graphql. Appolo Client front end deploy on netlify and backend on heroku. I used bootwatch them for this project",
    read: "10 min",
  },
  {
    link: "https://jmdb0808.netlify.app/",
    img: "https://res.cloudinary.com/junaid0808/image/upload/v1616844104/Profile/undraw_react_y7wq_loohlc.svg",
    name: "Movie DB",
    description:
      "React Application with omdb API. Routing with the help of React Router",
    read: "12 min",
  },
  {
    link: "https://junaid-githubsearch.netlify.app",
    img: "https://res.cloudinary.com/junaid0808/image/upload/v1616661578/Profile/undraw_Metrics_re_6g90_rir52d.svg",
    name: "GitHub User Search",
    description:
      "React Application With auth0 Fusion Chart. Where you can search the github user. I used the fusion chart and auth0 for login with social accounts.",
    read: "12 min",
  },
  {
    link: "https://covidtracker0808.netlify.app",
    img: "https://res.cloudinary.com/junaid0808/image/upload/v1616661452/Profile/quiz_mvpxft.svg",
    name: "Covid Tracker",
    description:
      "React Application. where you can search and choose the country for covid cases tracking and visualization of the data with chartJS. ",
    read: "16 min",
  },
  {
    link: "https://junaid-ecommerce.netlify.app/",
    img: "https://res.cloudinary.com/junaid0808/image/upload/v1616661578/Profile/undraw_Map_dark_re_36sy_pptpjj.svg",
    name: "E-Commerce",
    description: "React Application with Commerece JS. Coming Soon",
    read: "20 min",
  },
];
